module.exports = __webpack_public_path__ + "img/SP-Profi_Overview-Rear_2.127d9336.jpg";